import _ from 'lodash'

import DepositsStepV2 from "../StepContent/components/step/ProductSelectionStepsV2/components/DepositStep/DepositsStepV2";
import DepotStepV2 from "../StepContent/components/step/ProductSelectionStepsV2/components/DepotStep/DepotStepV2";
import SummaryStepV2 from "../StepContent/components/step/ProductSelectionStepsV2/components/SummaryStep";

import {
  DEPOT_OPENING_ONLY_OPTION_UID, DEPOT_OPENING_WITH_ASSET_OPTION_UID, EMPLOYER_STEP_ID,
  FIELD_REQUIRED_MSG, newDesignInputCustomClasses,
  OPTION_IS_NOT_AVAILABLE_FOR_DEPOT_MSG, PRODUCT_SELECTION_SUMMARY_STEP_ID, QUESTION_TYPE, radioNoUID, radioYesUID
} from "../../constants";
import CustodianStep from "../StepContent/components/step/ProductSelectionStepsV2/components/DepotStep/CustodianStep";
import EmployerInformationStep from "../StepContent/components/step/CustomerDataSteps/EmployerInformationStep";
import InvestmentLimitsStep
  from "../StepContent/components/step/ProductSelectionStepsV2/components/IndividualAssetManagement/InvestmentLimitsStep";
import CostDefinitions
  from "../StepContent/components/step/ProductSelectionStepsV2/components/IndividualAssetManagement/CostDefinitions";
import ExistingDepotStep
  from "../StepContent/components/step/ProductSelectionStepsV2/components/IndividualAssetManagement/ExistingDepotStep";
import {store} from "../../../../store";
import {displayErrorSnackBar} from "../../../../components/SnackbarProvider/actions";
import {
  MISSING_INSTRUMENTS_MSG
} from "../StepContent/components/step/ProductSelectionStepsV2/components/SummaryStep/SummaryStepV2";

const instrumentTypeStep = {
  "uid": "product-selection-deposits",
  "name": "Bitte wählen Sie die gewünschte Anlageart aus",
  "behaviour": ["dynamic"],
  "category": "Anlageart",
  "step_content": DepositsStepV2,
  "question": [
    {
      "uid": "single_investment['checkbox']",
      "type": "checkbox",
      "question_text": "Einzelfonds/Musterdepots"
    },
    {
      "uid": "pi['checkbox']",
      "type": "checkbox",
      "question_text": "Vermögensverwaltung",
    },
    {
      "uid": "individual_asset_management['checkbox']",
      "type": "checkbox",
      "question_text": "Individuelle Einzeltitelvermögensverwaltung",
      "afterChangeCallback": function (service) {
        // update steps
        if (this.answer){
          service.individualAssetManagementMountSteps();
        } else {
          service.individualAssetManagementUnmountSteps();
        }
      }
    },
    {
      "uid": "mp['checkbox']",
      "type": "checkbox",
      "question_text": "Modellportfolio"
    },
    {
      "uid": "portfolio_builder['checkbox']",
      "type": "checkbox",
      "question_text": "Portfolio-Builder"
    },
    {
      "uid": "vl_plan['checkbox']",
      "type": "checkbox",
      "question_text": "Vermögenswirksame Leistungen",
      "afterChangeCallback": function (service) {
        // update steps
        if (!this.answer){
          service.removeEmployerStep();
        } else {
          service.addEmployerStep();
        }
      }
    },
    {
      "uid": "einzeltitel['checkbox']",
      "type": 'checkbox',
      "question_text": 'Einzeltitel/Aktien'
    }
  ]
};

const productsStep = {
  "uid": "product-selection-investment-recommendation",
  "name": "Erstellen Sie eine Investmentanlage für Ihren Kunden/Ihrer Kundin",
  "behaviour": ["instruments_v2"],
  "category": "Anlageerstellung",
  "skippable": true,
  "custom_classes": {stepName: 'text-left no-margin'},
  "question": [
    {
      "uid": "instruments",
      "type": "input",
      "answer": [],
      "optional": true,
      "required_check": true,
    },
    {
      "uid": "instruments_source", // model portfolio or investment strategie
      "type": "input",
    },
    {
      "uid": "portfolio_builder_case",
      "type": "input",
    }
  ]
};

const custodianStep = {
  "uid": "product-selection-depot",
  "name": "Bitte wählen Sie die gewünschte Depotbank  für die Investmentanlage aus",
  "behaviour": ["dynamic"],
  "category": "Depotbank",
  "step_content": CustodianStep,
  "question": [
    {
      "uid": "custodians",
      "type": "radio_cards",
      "options": [],
      "config": {
        "choices": []
      }
    }
  ]
};

const depotTypeStep = {
  "uid": "product-selection-depot-type",
  "name": "Bitte wählen Sie die gewünschte Depotart aus",
  "behaviour": ["dynamic"],
  "category": "Depotart",
  "step_content": DepotStepV2,
  "question": [
    {
      "uid": "depot-type",
      "type": "input"
    }
  ]
};

const employerInformationStep = {
  "uid": EMPLOYER_STEP_ID,
  "behaviour": ["dynamic"],
  "category": "Arbeitgeber",
  "name": "Arbeitgeberinformationen von {customer_name}",
  "withUserName": true,
  "step_content": EmployerInformationStep,
  "question": [
    {
      "uid": "employer['company_name']",
      "question_text": "Arbeitgeber / Firma",
      "type": "input",
      "size": 6,
      "config": {
        "input_type": "",
        "mapping": {}
      },
      "optional": true,
      "custom_classes": newDesignInputCustomClasses,
    },
    {
      "uid": "employer['phone_number']",
      "question_text": "Telefonnummer",
      "type": "input",
      "size": 6,
      "behaviour": ["tel"],
      "config": {
        "input_type": "tel",
        "mapping": {}
      },
      "optional": true,
      "custom_classes": newDesignInputCustomClasses,
    },
    {
      "uid": "employer['street']",
      "question_text": "Straße",
      "type": "input",
      "size": 6,
      "config": {
        "input_type": "",
        "mapping": {}
      },
      "optional": true,
      "custom_classes": newDesignInputCustomClasses,
    },
    {
      "uid": "employer['street_number']",
      "question_text": "Hausnr.",
      "type": "input",
      "size": 6,
      "config": {
        "input_type": "tel",
        "mapping": {}
      },
      "optional": true,
      "custom_classes": newDesignInputCustomClasses,
    },
    {
      "uid": "employer['zip_code']",
      "question_text": "PLZ",
      "type": "input",
      "size": 6,
      "config": {
        "input_type": "tel",
        "mapping": {}
      },
      "optional": true,
      "custom_classes": newDesignInputCustomClasses,
    },
    {
      "uid": "employer['city']",
      "question_text": "Ort",
      "type": "input",
      "size": 6,
      "config": {
        "input_type": "",
        "mapping": {}
      },
      "optional": true,
      "custom_classes": newDesignInputCustomClasses,
    },
    {
      "uid": "employer['employee_id']",
      "question_text": "Personalnummer",
      "type": "input",
      "size": 6,
      "config": {
        "input_type": "",
        "mapping": {}
      },
      "optional": true,
      "custom_classes": newDesignInputCustomClasses,
    }
  ]
};

const depotOpeningStep = {
  "uid": "product-selection-depot-opening-type",
  "name": "Möchten Sie Einzahlungen tätigen?",
  "behaviour": ["dynamic"],
  "category": "Einzahlungen",
  "question": [
    {
      "uid": "depot-opening-type",
      "behaviour": ["radio_cards"],
      "size": 6,
      "optional": false,
      "config": {
        "choices": [
          {
            "id": 1,
            "uid": DEPOT_OPENING_ONLY_OPTION_UID,
            "text": "Mit leerem Depot fortfahren",
            "disabledReason": OPTION_IS_NOT_AVAILABLE_FOR_DEPOT_MSG,
          },
          {
            "id": 2,
            "uid": DEPOT_OPENING_WITH_ASSET_OPTION_UID,
            "text": "Mit Einzahlungen fortfahren"
          }
        ]
      },
      "afterChangeCallback": function (service) {
        // update steps
        if (this.answer === DEPOT_OPENING_ONLY_OPTION_UID && !service.openOnlyProductSelectionRequired){
          service.removeInstrumentsSteps();
        } else {
          service.addInstrumentsSteps();
        }
      }
    }
  ]
};

const validateWithMinMax = (q, afterChange) => {
  // TODO: Seems onAnswerChange triggered again after clicking Speichern button.
  //  As we have validateImmediately on this question - FIELD_REQUIRED_MSG cleaned right after assigning.
  //  A workaround for this case implemented to check if onAnswerChange triggered with empty answer.
  //  In case empty answer and FIELD_REQUIRED_MSG already set - do nothing and return false;
  const noAnswer = _.isNil(q.answer)
  if (q.error === FIELD_REQUIRED_MSG && afterChange && noAnswer) {
    return false
  }

  q.error = null;

  if (noAnswer) {
    if(!afterChange && !q.optional) {
      q.error = FIELD_REQUIRED_MSG;
    }
  } else if (q.maxValue !== undefined && q.answer > q.maxValue){
    q.error = q.getMaxValueError()
  } else if(q.minValue !== undefined && q.answer < q.minValue){
    q.error = q.getMinValueError()
  }

  return !q.error // if error is not set, the answer is valid
}

const summaryStep = {
  "uid": PRODUCT_SELECTION_SUMMARY_STEP_ID,
  "name": "",
  "behaviour": ["dynamic"],
  "category": "Anlageplan",
  "skippable": true,
  "step_content": SummaryStepV2,
  "question": [
    {
      "uid": "discounts",
      "type": "input",
      "question_text": "Anmerkung",
      "isValid": function (step, afterChange) {
        if(step.stepsData.instruments[0].length > 0){
          return true;
        } else {
          store.dispatch(displayErrorSnackBar(MISSING_INSTRUMENTS_MSG))
          return false;
        }
      },
      "config": {
        "choices": []
      }
    },
    {
      "uid": "kickback",
      "type": "select",
      "question_text": "Rückvergütung der Bestandsprovision",
      "optional": true,
      "config": {
        "choices": []
      }
    },
    {
      "uid": "serviceFee",
      "type": "input",
      "question_text": "Serviceentgelt p.a. (zzgl. MwSt.)",
      "validateImmediately": true,
      "isValid": function (step, afterChange) {
        return validateWithMinMax(this, afterChange)
      },
      "getMaxValueError": function() {return `Gebührenobergrenze ${this.maxValue}%`},
      "getMinValueError": function() {return `Gebührenuntergrenze ${this.minValue}%`},
    },
    {
      "uid": "serviceFeeVat",
      "type": "hidden",
      "question_text": "Serviceentgelt p.a. (inkl. MwSt.)",
      "optional": true
    }
  ]
};

export const productsStepsDataV2 = [
  instrumentTypeStep,
  custodianStep,
  depotTypeStep,
  employerInformationStep,
  depotOpeningStep,
  productsStep,
  summaryStep
];

export const getIndividualAssetManagementSteps = () => [
  {
    "uid": "existing-depot-step",
    "behaviour": ["dynamic"],
    "name": "Besitzt der Kunde/die Kundin bereits ein Comdirect-Depot, welches für die Individuelle Vermögensverwaltung genutzt werden soll? *",
    "category": "Depotabfrage",
    "step_content": ExistingDepotStep,
    "question": [
      {
        "uid": "has_existing_depot",
        "type": QUESTION_TYPE.RADIO_CARDS,
        "optional": false,
        "config": {
          "choices": [
            {
              "id": 1,
              "uid": radioYesUID,
              "text": "Ja"
            },
            {
              "id": 2,
              "uid": radioNoUID,
              "text": "Nein"
            }
          ]
        },
      }, {
        "uid": "depot_number",
        "question_text": "Depotnummer",
        "type": QUESTION_TYPE.INPUT,
        "custom_classes": newDesignInputCustomClasses,
        "optional": true,
        "size": 6,
      }, {
        "uid": "cash_account_number",
        "question_text": "Verrechnungskontonummer",
        "type": QUESTION_TYPE.INPUT,
        "custom_classes": newDesignInputCustomClasses,
        "optional": true,
        "size": 6,
      }
    ]
  },
  {
    "uid": "investment-limits-step",
    "name": "Definieren Sie die Anlagegrenzen für die Individuelle Einzeltitel-Vermögensverwaltung",
    "behaviour": ["dynamic"],
    "category": "Anlageerstellung",
    "custom_classes": {stepName: 'text-left no-margin'},
    "step_content": InvestmentLimitsStep,
    "question": [
      {
        "uid": "sri",
        "type": QUESTION_TYPE.INPUT,
        "optional": false,
        "isValid": function(step, afterChange, service){
          this.error = null;

          if(!this.answer){
            this.error = FIELD_REQUIRED_MSG;
          } else if(this.answer > service._srri){
            this.error = "Das Risikoprofil der Strategie kann nicht höher sein als die Risikoklasse des Kunden.";
          }

          return !this.error;
        }
      },
      {
        "uid": "investment-limits",
        "type": QUESTION_TYPE.INPUT,
        "optional": false,
        "isValid": function (step, afterChange, service){
          return !_.isEmpty(this.answer)
        }
      }
    ]
  },
  {
    "uid": "cost-definition-step",
    "name": "",
    "behaviour": ["dynamic"],
    "category": "Anlageplan",
    "custom_classes": {stepName: 'text-left no-margin'},
    "step_content": CostDefinitions,
    "question": [
      {
        "uid": "invested_amount",
        "type": QUESTION_TYPE.INPUT,
        "optional": false,
        "validateImmediately": true,
        "isValid": function (step, afterChange) {
          return validateWithMinMax(this, afterChange)
        },
        "getMinValueError": function(){
          return 'Bitte Mindestanlage beachten.'
        },
      },
      {
        "uid": "ongoing_cost",
        "question": [
          {
            "uid": "active_fonds",
            "question_text": "Laufende Kosten Aktive Fonds je RK",
            "type": QUESTION_TYPE.INPUT,
            "answer": 0,
          },
          {
            "uid": "etf",
            "question_text": "Laufende Kosten ETFs",
            "type": QUESTION_TYPE.INPUT,
            "answer": 0,
          },
          {
            "uid": "einzeltitel",
            "question_text": "Laufende Kosten Einzeltitel",
            "type": QUESTION_TYPE.INPUT,
            "answer": 0,
          }
        ],
        "isValid": function (step, afterChange, service) {
          this.error = null;

          if(_.sumBy(this.question, 'answer') !== 100){
            this.error = 'Verteilung muss insgesamt 100% ergeben.'
          }

          return !this.error;
        }
      },
      {"uid": "ongoing_cost_config", "type": "hidden"},
      {
        "uid": "avg_transaction_amount",
        "type": QUESTION_TYPE.INPUT,
        "question_text": "ø Anlagebetrag je Kauf/Verkauf",
        "optional": false,
        "custom_classes": newDesignInputCustomClasses,
      },
      {
        "uid": "number_of_trades",
        "question": [
          {
            "uid": "kvg",
            "question_text": "Anzahl der Käufe und Verkäufe über KVG ø p.a.",
            "type": QUESTION_TYPE.INPUT,
            "optional": false,
          },
          {
            "uid": "exchange",
            "question_text": "Anzahl der Käufe und Verkäufe über Börse ø p.a.",
            "type": QUESTION_TYPE.INPUT,
            "optional": false,
          },
        ]
      },
      {
        "uid": "service_fees",
        "validateImmediately": true,
        "question": [
          {
            "uid": "vv_fee",
            "question_text": "VV-Entgelt laufend",
            "type": QUESTION_TYPE.INPUT,
            "optional": false,
            "validateImmediately": true,
            "isValid": function (step, afterChange) {
              return validateWithMinMax(this, afterChange)
            },
            "getMaxValueError": function() {return `Gebührenobergrenze ${this.maxValue}%`},
            "getMinValueError": function() {return `Gebührenuntergrenze ${this.minValue}%`},
            "storeFields": ["minValue"]
          },
          {
            "uid": "vv_fee_vat",
            "question_text": "VV-Entgelt laufend (inkl. MwSt.)",
            "type": QUESTION_TYPE.INPUT,
            "optional": false,
          },
          {
            "uid": "entry_fee",
            "question_text": "Einstiegsentgelt einmalig",
            "type": QUESTION_TYPE.INPUT,
            "optional": false,
            "validateImmediately": true,
            "isValid": function (step, afterChange) {
              return validateWithMinMax(this, afterChange)
            },
            "getMaxValueError": function() {return `Gebührenobergrenze ${this.maxValue}%`},
            "getMinValueError": function() {return `Gebührenuntergrenze ${this.minValue}%`},
          },
          {
            "uid": "entry_fee_vat",
            "question_text": "Einstiegsentgelt einmalig (inkl. MwSt.)",
            "type": QUESTION_TYPE.INPUT,
            "optional": false,
          },
        ]
      }
    ]
  }
]